import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-gutter w-full max-w-750 mx-auto md:my-20" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 2,
  class: "mb-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaHandler = _resolveComponent("MediaHandler")!
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_MediaHandler, {
      "video-disable-on-mobile": _ctx.content.disableVideoOnMobile,
      "media-aspect-ratio": _ctx.aspectRatio,
      "media-block": _ctx.tileContentBlock.media
    }, null, 8, ["video-disable-on-mobile", "media-aspect-ratio", "media-block"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.tileContentBlock.subheading)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "o-text-caption uppercase m-0",
            innerHTML: _ctx.tileContentBlock.subheading
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.tileContentBlock.title)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 1,
            class: "mb-10",
            innerHTML: _ctx.tileContentBlock.title
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.tileContentBlock.text)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.tileContentBlock.text), 1))
        : _createCommentVNode("", true),
      (_ctx.tileContentBlock.link)
        ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
            key: 3,
            class: "mt-15 text-center",
            "link-block": _ctx.tileContentBlock.link,
            "style-as-button": !_ctx.content.alternativeLinkStyle
          }, null, 8, ["link-block", "style-as-button"]))
        : _createCommentVNode("", true)
    ])
  ]))
}